import React from "react";

interface SpaceViewProps {
    frameObj: React.ReactNode;
    isVisible: boolean;
}
export default function SpaceView(props: SpaceViewProps) {
    return props.isVisible ? <div className="space-view">{props.frameObj}</div> : null;
}
